import React, { useState } from "react";
import { Share2 } from "lucide-react";
import Swal from "sweetalert2";

const copyToClipboard = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }
  return new Promise((resolve, reject) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      resolve();
    } catch (error) {
      reject(error);
    } finally {
      document.body.removeChild(textArea);
    }
  });
};

export function ShareButton({
  url,
  title = "",
  label = "Share",
  variant = "outline",
  className = "",
}) {
  const [copied, setCopied] = useState(false);

  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 cursor-pointer px-6 py-2";

  const solid =
    "bg-[#FF6600] text-white hover:bg-[#E65100] shadow-lg hover:shadow-xl transform hover:-translate-y-0.5";

  const outline =
    "border-2 border-[#f89816] text-[#f89816] hover:bg-[#f89816] hover:text-white";

  const handleClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error && error.name === "AbortError") return;
      }
    }

    try {
      await copyToClipboard(url);
      setCopied(true);
      Swal.fire({
        icon: "success",
        title: "Link Copied!",
        text: "The fundraiser link has been copied to your clipboard.",
        confirmButtonColor: "#FF6600",
        confirmButtonText: "OK",
        timer: 2500,
        timerProgressBar: true,
      });
    } catch (error) {
      console.error("Failed to copy link:", error);
      Swal.fire({
        icon: "error",
        title: "Couldn't copy link",
        text: "Please copy the link manually from your browser's address bar.",
        confirmButtonColor: "#FF6600",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${base} ${variant === "solid" ? solid : outline} ${className}`}
    >
      <Share2 className="w-5 h-5" />
      {copied ? "Copied!" : label}
    </button>
  );
}
